import * as v4ActionModal from 'actions/V4Actions/v4ActionModal';
import * as v4ActionTab from 'actions/V4Actions/v4ActionsTab';
import { AsyncStatus } from 'utils/asyncStatusHelper';
import { createPageTree } from './pageDataReducer';
import productPageMetadataReducer from './productPageMetadataReducer';
import get from 'lodash/get';
const { MODAL_PAGE_DATA_ACTIONS } = v4ActionModal;
const { TAB_DATA_ACTIONS } = v4ActionTab;
const DefaultModalOptions = {
    modalSettings: undefined,
    ModalLoader: undefined,
    persistData: false,
    asyncStatus: AsyncStatus.INIT
};
const defaultState = {
    asyncStatus: AsyncStatus.INIT,
    data: { ROOT: [] },
    pageNumber: 0,
    timeStamp: new Date().getTime(),
    derivedMetaData: {}
};
export function createV4Reducer(requestAction, successAction, errorAction, clearAction) {
    return function (state = defaultState, action) {
        switch (action.type) {
            case requestAction: {
                const { modalOptions = {}, fetchOptions = {} } = action;
                return Object.assign(Object.assign(Object.assign(Object.assign({}, state), { asyncStatus: AsyncStatus.LOADING, prevType: state.type, pageType: action.pageType }), modalOptions), { fetchOptions });
            }
            case successAction: {
                const _data1 = action;
                const slots = get(_data1, 'data.slots');
                const { modalOptions = {}, pageDataOptions = {}, fetchOptions } = action;
                const subPageResponseMap = get(action, [
                    'data',
                    'subPageResponseMap'
                ]);
                if (!slots) {
                    return Object.assign(Object.assign(Object.assign({}, state), { asyncStatus: AsyncStatus.SUCCESS }), modalOptions);
                }
                return Object.assign(Object.assign(Object.assign({}, state), { asyncStatus: AsyncStatus.SUCCESS, data: createPageTree(slots).pageTree, timeStamp: new Date().getTime(), pageMeta: _data1.data.pageMeta, 
                    // TODO: for the time being using this reducer directly, later we need to shift this to a util function.
                    derivedMetaData: productPageMetadataReducer(state.derivedMetaData, action), pageData: Object.assign(Object.assign({}, _data1.data.pageData), pageDataOptions), subPageResponse: subPageResponseMap, fetchOptions: fetchOptions || state.fetchOptions }), modalOptions);
            }
            case errorAction: {
                const _data1 = action;
                const { modalOptions = {} } = action;
                return Object.assign(Object.assign(Object.assign({}, state), { asyncStatus: AsyncStatus.ERROR, error: _data1.error }), modalOptions);
            }
            case clearAction: {
                if (action.clearModalOptions) {
                    return Object.assign(Object.assign({}, state), DefaultModalOptions);
                }
                return defaultState;
            }
            default:
                return state;
        }
    };
}
export const modalDataReducer = createV4Reducer(MODAL_PAGE_DATA_ACTIONS.REQUEST, MODAL_PAGE_DATA_ACTIONS.SUCCESS, MODAL_PAGE_DATA_ACTIONS.ERROR, MODAL_PAGE_DATA_ACTIONS.CLEAR);
export const tabDataReducer = createV4Reducer(TAB_DATA_ACTIONS.REQUEST, TAB_DATA_ACTIONS.SUCCESS, TAB_DATA_ACTIONS.ERROR, TAB_DATA_ACTIONS.CLEAR);
